export function isUpgrade(item) {
    return item?.type === "Upgrade";
}
export function isVIPUpgrade(item) {
    return item?.type === "VIPUpgrade";
}
//# sourceMappingURL=upgrade.js.map